module.exports = __webpack_public_path__ + "static/media/marketplace_explanation.22ff3f4f.PNG";